module.exports = __webpack_public_path__ + "media/images/dan_lennie-dbb2ecb9777a11a02b7bc49dab7aa39d.png";